// extracted by mini-css-extract-plugin
module.exports = {"container":"overlay_container__2ZmCj"};
    if(module.hot) {
      // 1785568525939
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  